import React from "react";
import {Route, Routes} from "react-router-dom";
import Login from "../pages/Login";
// import Blank from "../pages/Blank";
// import Home from "../pages/Home";
import DaySchedule from "../pages/DaySchedule";
import EditSchedule from "../pages/EditSchedule";
import Schedules from "../pages/Schedules";
import Shifts from "../pages/Shifts";
import Instructions from "../pages/Instructions";
import ToastMessages from "../pages/partial/ToastMessages";
import "../stylesheets/css.css";
import {menuList} from "./menuList";

const IsAuthority = (props) => {
  const thisMenu = (menuList.map((menu) => {
    return menu.children.find((child) => child[1].includes(props.route))
  }) || [])[0];
  const authority = !Boolean(thisMenu[2]) || Boolean(sessionStorage.getItem(thisMenu[2]));
  return authority && props.element;
};

export const Router = React.memo(() => {
  const [state, setState] = React.useState({
    message: sessionStorage.getItem("toastMessage"),
    error: sessionStorage.getItem("toastError")
  });

  return (
    <>
    <ToastMessages
      open = {Boolean(state.message) || state.networkError}
      close = {() => setState({...state, message: "", networkError: false})}
      severity = {state.error ? "error" : "success"}
      messages = {!(state.networkError) ? state.message : "サーバからの応答がありません。"}
    />
    <Routes>
      <Route path = "/" element = {<Login toastState = {state} setToastState = {setState} />} />
      {/* <Route path = "/fail_login" element = {<Blank toastState = {state} setToastState = {setState} />} /> */}
      {/* <Route path = "/home" element = {<Home />} /> */}
      <Route path = "/day_schedule" element = {<IsAuthority element = {<DaySchedule toastState = {state} setToastState = {setState} />} route = "/day_schedule" />} />
      <Route path = "/edit_schedule" element = {<IsAuthority element = {<EditSchedule toastState = {state} setToastState = {setState} />} route = "/edit_schedule" />} />
      <Route path = "/schedules" element = {<IsAuthority element = {<Schedules toastState = {state} setToastState = {setState} />} route = "/schedules" />} />
      <Route path = "/shifts" element = {<IsAuthority element = {<Shifts toastState = {state} setToastState = {setState} />} route = "/shifts" />} />
      <Route path = "/instructions" element = {<IsAuthority element = {<Instructions toastState = {state} setToastState = {setState} />} route = "/instructions" />} />
      {/* <Route path = "/template" element = {<IsAuthority element = {<Template toastState = {state} setToastState = {setState} />} route = "/template" />} /> */}
    </Routes>
    </>
  );
});
